import { render, staticRenderFns } from "./WebGLCanvas.vue?vue&type=template&id=5f3308e9&scoped=true&"
import script from "./WebGLCanvas.vue?vue&type=script&lang=js&"
export * from "./WebGLCanvas.vue?vue&type=script&lang=js&"
import style0 from "./WebGLCanvas.vue?vue&type=style&index=0&id=5f3308e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3308e9",
  null
  
)

component.options.__file = "WebGLCanvas.vue"
export default component.exports